export { default as CinchShieldLogo } from './cinch_Shield_logo.svg'
export { default as CinchChargeLogo } from './cinch_Charge_logo.svg'
export { default as CinchChargePurpleLogo } from './cinch_Charge_purple_logo.svg'
export { default as CinchCoverColourLogo } from './cinch_Cover_colour_logo.svg'
export { default as CinchCoverWhiteLogo } from './cinch_Cover_white_logo.svg'
export { default as Car } from './car.svg'
export { default as Heart } from './heart.svg'
